import { Stores } from '../pages/Stores/Stores';
import { Products } from '../pages/Products/Products';
import { Home } from '../pages/home/Home';
import { Orders } from '../pages/Orders/Orders';
import { ProductionPlan } from '../pages/Production/ProductionPlan';
import { Categories } from '../pages/Categories/Categories';
import { CreateProduct } from '../pages/Products/CreateProduct';
import { SubCategories } from '../pages/Categories/SubCategories/SubCategories';
import { RecipeBuilder } from '../pages/RecipeBuilder/RecipeBuilderReport';
import { ShippingMemos } from '../pages/Shipping/ShippingMemos';
import { Invoices } from '../pages/Invoices/Invoices';
import { InvoiceDetails } from '../pages/Invoices/InvoiceDetails';
import { ShippingDetails } from '../pages/Shipping/ShippingDetails';
import { OrderDetails } from '../pages/Orders/OrderDetails';
import { StoreProducts } from '../pages/Stores/StoreProducts';
//import { ProductDetails } from '../pages/Products/ProductDetails';
import { AddEditStore } from '../pages/Stores/AddEditStore';
import { Messages } from '../pages/messages/Messages';
import { Profile } from '../pages/Profile/Profile';
import { MessagesThread } from '../pages/messages/MessagesThread';
import { ActiveOrders } from '../pages/ActiveOrders/ActiveOrders';
import { ConsolidatedRecipeBuilder } from '../pages/RecipeBuilder/ConsolidatedRecipeBuilder';
import { ProductionReport } from '../pages/Production/ProductionReport';
import { ProductionReportDetails } from '../pages/Production/ProductionReportDetails';

export const routesList: Array<Object> = [
  { path: '/', component: Home },
  { path: '/profile', component: Profile },
  { path: '/products', component: Products },
  { path: '/orders', component: Orders },
  { path: '/activeOrders', component: ActiveOrders },
  { path: '/orderDetails', component: OrderDetails },
  { path: '/productionPlan', component: ProductionPlan },
  { path: '/productionReportHistory', component: ProductionReport },
  { path: '/productionReportDetails', component: ProductionReportDetails },
  { path: '/categories', component: Categories },
  { path: '/stores', component: Stores },
  { path: '/addEditStore', component: AddEditStore },
  { path: '/storeProducts', component: StoreProducts },
  { path: '/createProduct', component: CreateProduct },
  //{ path: '/productDetails', component: ProductDetails },
  // {
  //   path: "/storeDetails",
  //   component: StoreDetails,
  // },
  { path: '/subCategories', component: SubCategories },
  { path: '/recipeBuilder', component: RecipeBuilder },
  { path: '/consolidatedRecipeBuilder', component: ConsolidatedRecipeBuilder },
  { path: '/shippingMemos', component: ShippingMemos },
  { path: '/shippingdetails', component: ShippingDetails },
  { path: '/order-processing', component: ActiveOrders },
  { path: '/invoices', component: Invoices },
  { path: '/invoiceDetails', component: InvoiceDetails },
  { path: '/messages', component: Messages },
  { path: '/messagesThread', component: MessagesThread }
];
